import { createSlice } from '@reduxjs/toolkit';
import { submitContactForm } from '../actions/contactUsActions';

const initialState = {
  isLoading: false,
  error: null,
  success: false,
  message: null,
};

const contactUsSlice = createSlice({
  name: 'contactUs',
  initialState,
  reducers: {
    clearContactForm: (state) => {
      state.isLoading = false;
      state.error = null;
      state.success = false;
      state.message = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(submitContactForm.pending, (state) => {
        state.isLoading = true;
        state.error = null;
        state.success = false;
        state.message = null;
      })
      .addCase(submitContactForm.fulfilled, (state, action) => {
        state.isLoading = false;
        state.success = true;
        state.message = action.payload?.message || 'تم إرسال الرسالة بنجاح';
        state.error = null;
      })
      .addCase(submitContactForm.rejected, (state, action) => {
        state.isLoading = false;
        state.success = false;
        state.error = action.payload || 'حدث خطأ أثناء إرسال الرسالة';
        state.message = null;
      });
  },
});

export const { clearContactForm } = contactUsSlice.actions;
export default contactUsSlice.reducer;
